export default "__VITE_ASSET__qQn7KPv0__"